import React from 'react';
import '../DevelopmentTools/DevelopmentTools.css';

function DesktopAppPL({ onNavigate, isFirst, isLast }) {
  return (
    <div className="use-case-container">
      <div className="use-case-header">
        <h3 className="use-case-title">
          Aplikacja Desktopowa / Wiodące światowe firmy logistyczne
        </h3>
        <div className="navigation-buttons">
          <button
            onClick={() => onNavigate('prev')}
            disabled={isFirst}
            className="nav-button"
          >
            &lt;
          </button>
          <button
            onClick={() => onNavigate('next')}
            disabled={isLast}
            className="nav-button"
          >
            &gt;
          </button>
        </div>
      </div>

      {/* Overview */}
      <div id="desktopapp-overview" className="use-case-section">
        <h2 className="section-title">Przegląd</h2>
        <div className="overview-content">
          <p>
            <strong>Udoskonalałam aplikacje desktopowe dla logistyki</strong>, koncentrując się na:
          </p>
          <ul className="overview-list">
            <li>
              <strong>Użyteczności:</strong> Tworzeniu intuicyjnej nawigacji i jasnych instrukcji dla bezproblemowych interakcji użytkownika.
            </li>
            <li>
              <strong>Estetyce:</strong> Projektowaniu atrakcyjnych wizualnie interfejsów, które angażują użytkownika.
            </li>
            <li>
              <strong>Spójności:</strong> Utrzymaniu jednolitych elementów designu, by budować poczucie znajomości i łatwości obsługi.
            </li>
            <li>
              <strong>Optymalizacji wydajności:</strong> Współpracy z zespołami developerskimi, by zapewnić szybkie reakcje i płynne interakcje.
            </li>
          </ul>
          <p>
            Takie podejście sprawia, że aplikacje logistyczne są funkcjonalne, satysfakcjonujące i efektywne dla użytkowników.
          </p>
        </div>
      </div>

      {/* Specification */}
      <div id="desktopapp-specification" className="use-case-section">
        <h2 className="section-title">Specyfikacja</h2>
        <div className="specification-content">
          <h1 className="tool-name">Wiodąca światowa firma logistyczna</h1>
          <div className="spec-details">
            <div className="spec-row">
              <div className="spec-label">Czas trwania:</div>
              <div>2 miesiące</div>
            </div>
            <div className="spec-row">
              <div className="spec-label">Wykorzystane narzędzia:</div>
              <div>Figma, Confluence</div>
            </div>
          </div>
          <div>
            <h3 className="highlight-blue" style={{ fontWeight: 'bold' }}>Cel</h3>
            <p className="goal-text">
              Zwiększenie produktywności i satysfakcji użytkowników w aplikacji desktopowej dla logistyki.
            </p>
          </div>
          <img
            src={require("../../../../assets/use-case-specification.png")}
            alt="Ilustracja specyfikacji use case"
            className="specification-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginTop: '2rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
        </div>
      </div>

      {/* Problem Challenge */}
      <div id="desktopapp-problem" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue">Wyzwanie</span> – problem
        </h2>
        <div className="problem-content">
          <p>
            W roli UX designera dla <strong>wiodącej globalnej firmy logistycznej</strong> stanęłam przed wyzwaniem <strong>ograniczonego bezpośredniego dostępu do użytkowników końcowych</strong>. Aby temu zaradzić, opracowałam projekt oparty na <strong>uznanych zasadach użyteczności</strong> i <strong>ogólnych wytycznych UX</strong>. Takie podejście zapewniło, że aplikacja była przyjazna, efektywna i zgodna z najlepszymi praktykami branżowymi – nawet bez bezpośredniego udziału użytkowników.
          </p>
          <div className="impact-section">
            <h3 className="highlight-blue">Mój wpływ</h3>
            <p>W tym projekcie skupiłam się na:</p>
            <ul className="impact-list">
              <li>
                <strong>Udoskonaleniu istniejącego interfejsu:</strong> Przeprowadziłam ewaluacje heurystyczne, stosując zasady użyteczności Jakoba Nielsena, by poprawić interfejs i funkcjonalność narzędzia.
              </li>
              <li>
                <strong>Redesignie dla spójności z marką:</strong> Odświeżyłam interfejs narzędzia, by był zgodny z brand guidelines, zapewniając harmonię wizualną i lepszą użyteczność.
              </li>
            </ul>
            <p>
              Dzięki tym strategiom projekt spełniał <strong>uznane standardy użyteczności</strong>, co przełożyło się na <strong>bardziej intuicyjne i efektywne</strong> doświadczenie użytkownika.
            </p>
          </div>
        </div>
      </div>

      {/* The Process Approach */}
      <div id="desktopapp-process" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue">Proces</span> – podejście
        </h2>
        <div className="process-content">
          <p>
            W tym projekcie podkreśliłam zasady projektowania i wykorzystałam swoją wiedzę, by poprawić doświadczenie użytkownika.
          </p>

          <h3 className="highlight-blue">Ewaluacja heurystyczna dla lepszej użyteczności aplikacji</h3>
          <p>
            Przeprowadziłam <strong>ewaluacje heurystyczne</strong>, by poprawić użyteczność aplikacji, oceniając interfejs według <strong>10 heurystyk użyteczności Jakoba Nielsena</strong>:
          </p>

          <h3 className="highlight-blue">1. Widoczność statusu systemu</h3>
          <p>
            Zapewnienie użytkownikom <strong>natychmiastowej informacji zwrotnej</strong> o ich działaniach poprzez wdrożenie czytelnych mechanizmów, takich jak <strong>wizualne wskazówki</strong>.
          </p>

          <h3 className="highlight-blue">2. Zgodność systemu ze światem rzeczywistym</h3>
          <p>
            Wykorzystanie <strong>intuicyjnych rozwiązań</strong>, które odzwierciedlają rzeczywiste interakcje, czyniąc system <strong>bardziej naturalnym i znajomym</strong>.
          </p>

          <h3 className="highlight-blue">3. Kontrola i swoboda użytkownika</h3>
          <p>
            Umożliwienie użytkownikom <strong>cofania błędów</strong>, <strong>swobodnej nawigacji</strong> i <strong>odzyskiwania utraconej pracy</strong>, co zmniejsza frustrację i zwiększa pewność siebie.
          </p>

          <h3 className="highlight-blue">4. Spójność i standardy</h3>
          <p>
            Utrzymanie <strong>jednolitego designu</strong>, <strong>terminologii</strong> i <strong>wytycznych dla platformy</strong>, by system był przewidywalny i przyjazny na różnych ekranach.
          </p>

          <h3 className="highlight-blue">5. Zapobieganie błędom</h3>
          <p>
            Proaktywne ograniczanie błędów poprzez <strong>minimalizowanie kosztownych pomyłek</strong> i zwiększanie pewności użytkownika dzięki projektowaniu zapobiegawczemu.
          </p>

          <h3 className="highlight-blue">6. Rozpoznawanie zamiast przypominania</h3>
          <p>
            <strong>Usprawnienie nawigacji</strong> przez uczynienie opcji <strong>widocznymi i łatwymi do rozpoznania</strong>, by użytkownicy polegali na rozpoznawaniu, a nie pamięci.
          </p>

          <h3 className="highlight-blue">7. Elastyczność i efektywność</h3>
          <p>
            Zapewnienie <strong>skrótów klawiaturowych</strong>, <strong>personalizacji</strong> i inteligentnych <strong>workflowów</strong>, by odpowiadać zarówno początkującym, jak i zaawansowanym użytkownikom.
          </p>

          <h3 className="highlight-blue">8. Estetyka i minimalistyczny design</h3>
          <p>
            <strong>Uproszczenie interfejsu</strong> przez usunięcie zbędnych elementów, utrzymanie przejrzystej hierarchii i skupienie się na kluczowych funkcjach.
          </p>

          <h3 className="highlight-blue">9. Pomoc w rozpoznawaniu, diagnozowaniu i naprawianiu błędów</h3>
          <p>
            Projektowanie <strong>czytelnych, pomocnych komunikatów o błędach</strong>, które pomagają użytkownikom szybko zidentyfikować i rozwiązać problem.
          </p>

          <h3 className="highlight-blue">10. Pomoc i dokumentacja</h3>
          <p>
            Zapewnienie użytkownikom łatwego dostępu do <strong>pomocy</strong> i <strong>przeszukiwalnej dokumentacji</strong> bez przerywania pracy.
          </p>
        </div>
      </div>

      {/* Solution Ideation */}
      <div id="desktopapp-solution" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Rozwiązanie</span> – ideacja
        </h2>
        <div className="solution-content">
          <img
            src={require("../../../../assets/solution-ideation.png")}
            alt="Ilustracja ideacji rozwiązania"
            className="solution-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginBottom: '1.5rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
          <p>
            Dzięki wdrożeniu tych rozwiązań aplikacja stała się bardziej intuicyjna, efektywna i przyjazna użytkownikowi, zgodnie z najlepszymi praktykami branżowymi.
          </p>

          <h3 className="highlight-blue" style={{ fontWeight: 'bold' }}>Zastosowanie 10 heurystyk użyteczności Jakoba Nielsena pozwoliło na:</h3>
          <ul className="solution-list">
            <li>
              <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Lepszą użyteczność</span> – Jasna informacja zwrotna, intuicyjna nawigacja i zapobieganie błędom zmniejszyły tarcia w interakcjach.
            </li>
            <li>
              <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Większą produktywność</span> – Usprawnione workflowy, skróty klawiaturowe i sprytne domyślne ustawienia przyspieszyły realizację zadań.
            </li>
            <li>
              <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Wyższą satysfakcję użytkowników</span> – Czysty, spójny i responsywny design poprawił całościowe doświadczenie.
            </li>
            <li>
              <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Mniej błędów</span> – Walidacja danych, pomocne komunikaty o błędach i opcje odzyskiwania zminimalizowały pomyłki i frustrację.
            </li>
          </ul>

          <h3 className="highlight-blue" style={{ fontWeight: 'bold' }}>Uproszczenie interfejsu przez:</h3>
          <ul className="solution-list">
            <li>Usunięcie przestarzałych elementów</li>
            <li>Wprowadzenie czystego, nowoczesnego i responsywnego układu</li>
            <li>Współpracę z technical writers, by zapewnić zwięzłe i przyjazne teksty w interfejsie</li>
          </ul>

          <p>
            Ten proces potwierdził wartość uporządkowanej ewaluacji UX i jej bezpośredni wpływ na zaangażowanie użytkowników oraz efektywność systemu.
          </p>
        </div>
      </div>

      {/* Conclusion */}
      <div id="desktopapp-conclusion" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Podsumowanie</span>
        </h2>
        <div className="conclusion-content">
          <h3 style={{ color: '#aaa', marginBottom: '1rem' }}>Osiąganie celów użyteczności bez bezpośredniego feedbacku od użytkowników</h3>
          <p>
            Zastosowanie <strong>10 heurystyk użyteczności Jakoba Nielsena</strong> dało mi głębsze zrozumienie, co tworzy dobre doświadczenie użytkownika. Jednak wyzwaniem było zrobienie tego <span className="highlight-blue" style={{ fontWeight: 'bold' }}>bez bezpośredniego dostępu do realnych użytkowników</span>.
          </p>
          <p>Czego nauczyłam się w tym procesie:</p>
          <ul className="solution-list">
            <li>
              <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Ludzie potrzebują jasnej informacji zwrotnej</span>. Gdy użytkownicy wiedzą, co się dzieje – czy to pasek ładowania, komunikat o sukcesie czy błąd – czują się pewniej i mają większą kontrolę.
            </li>
            <li>
              <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Błędy powinny być łatwe do naprawienia</span> <strong>(lub zapobiegane)</strong>. Dając użytkownikom przycisk "cofnij" lub szybkie ostrzeżenie przed usunięciem czegoś ważnego, zapobiegamy frustracji.
            </li>
            <li>
              <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Mniej znaczy więcej</span>. Czysty, prosty design bez zbędnych elementów pozwala użytkownikom skupić się i szybciej realizować zadania.
            </li>
            <li>
              <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Każdy pracuje inaczej</span>. Niektórzy użytkownicy uwielbiają skróty i zaawansowane funkcje, inni wolą prowadzenie krok po kroku. Dobry interfejs powinien odpowiadać obu grupom.
            </li>
            <li>
              <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Pomoc powinna być łatwo dostępna</span>. Nikt nie chce przekopywać się przez instrukcję – podpowiedzi, tooltipy i sprytne komunikaty o błędach robią ogromną różnicę.
            </li>
          </ul>
          <p>
            Praca <strong>bez realnego feedbacku od użytkowników</strong> oznaczała <strong>opieranie się na najlepszych praktykach</strong> i <strong>zasadach użyteczności</strong>, a nie na bezpośrednich obserwacjach. Choć <span className="highlight-blue" style={{ fontWeight: 'bold' }}>heurystyki to świetne ramy</span>, prawdziwi użytkownicy wnoszą nieoczekiwane spostrzeżenia, których nie da się przewidzieć. Mimo tego wyzwania cel został osiągnięty :) wdrożone usprawnienia pomagają użytkownikom.
          </p>
        </div>
      </div>
    </div>
  );
}

export default DesktopAppPL; 